import { BaseCommand } from './BaseCommand';
import type { PromptCommandCategory } from './PromptCommandCategory';
import { sendAnalyticsEvent } from '~/lib/analytics.client';
import type { CommandActionContext, CommandShortcut } from '~/lib/stores/command/types';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';

export class BoltPromptCommand extends BaseCommand {
  prompt: string;
  category?: PromptCommandCategory;

  constructor(details: { id: string; name: string; icon?: string; prompt: string; category?: PromptCommandCategory }) {
    super({ id: details.id, name: details.name, icon: details.icon });
    this.prompt = details.prompt;
    this.category = details.category;
  }

  action({ setInput }: CommandActionContext) {
    setInput(this.prompt);

    sendAnalyticsEvent({
      action: AnalyticsAction.Track,
      payload: {
        event: AnalyticsTrackEvent.PromptLibraryPromptUsed,
        properties: {
          promptId: this.id,
          promptTitle: this.name,
          categoryId: this.category?.id,
          categoryName: this.category?.name,
        },
      },
    });
  }

  shortcuts: CommandShortcut[] = [
    {
      label: 'Use Prompt',
      keys: ['Enter'],
      action: (context) => this.action(context),
    } satisfies CommandShortcut,
    {
      id: 'favorite',
      label: 'Toggle Favorite',
      keys: ['Meta', 'Shift', 'L'],
      action: ({ commandStore }) => {
        commandStore.toggleFavorite(this.id);

        sendAnalyticsEvent({
          action: AnalyticsAction.Track,
          payload: {
            event: AnalyticsTrackEvent.PromptLibraryPromptStarred,
            properties: {
              promptId: this.id,
              promptTitle: this.name,
              categoryId: this.category?.id,
              categoryName: this.category?.name,
            },
          },
        });
      },
    } satisfies CommandShortcut,
  ];
}
